<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BkEWiN/tc-custom/9780316175500.jpg?1733081734064" alt="This image is the cover for the book Saints and Sinners"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saints and Sinners
      </h1>
      <p class="bookDescription body article font2">
        <p>With her inimitable gift for describing the workings of the heart and mind, Edna O'Brien introduces us to a vivid new cast of restless, searching people who-whether in the Irish countryside or London or New York-remind us of our own humanity. <br/><br/> In <i>Send My Roots Rain</i>, Miss Gilhooley, a librarian, waits in the lobby of a posh Dublin hotel-expecting to meet a celebrated poet while reflecting on the great love who disappointed her. The Irish workers of "The Shovel Kings" have pipe dreams of becoming millionaires in London, but long for their quickly changing homeland-exiles in both places. "Green Georgette" is a searing anatomy of class, through the eyes of a little girl; "Old Wounds" illuminates the importance of family and memory in old age. In language that is always bold and vital, Edna O'Brien pays tribute to the universal forces that rule our lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edna O'Brien
      </h2>
      
      <p class="authorDescription body article">Edna O'Brien is the author of <I>The Country Girls</I> trilogy, <I>The Light of Evening</I>, <I>The Love Object</I>, and many other acclaimed books. Born and raised in the west of Ireland, O'Brien has lived in London for many years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?caee3982